/** @format */

import styled from 'styled-components';

export const StyledIconWrapper = styled.div`
  position: absolute;
  margin-top: 7px;
  margin-left: 7px;
`;
